(() => {
  const BUTTON_CLASS = 'ja-pinterest-save-button';
  const QUICK_ADD_SELECTOR = '.quick-add-modal__content';

  class JaProductPinterestSave extends HTMLElement {
    connectedCallback() {
      if (this.initialized || this.closest(QUICK_ADD_SELECTOR)) return;

      this.initialized = true;

      window.requestAnimationFrame(() => {
        if (!this.isConnected || this.closest(QUICK_ADD_SELECTOR)) return;

        this.gallery = this.closest('media-gallery');
        if (!this.gallery) return;

        this.productTitle = this.dataset.productTitle || document.title;
        this.productUrl = normalizeUrl(this.dataset.productUrl || window.location.pathname);
        this.fallbackImageUrl = normalizeUrl(this.dataset.fallbackImageUrl || '');

        this.prepareImages();
        this.mountButtons();
      });
    }

    mountButtons() {
      const isGrid = this.gallery.classList.contains('media-gallery--grid');

      this.mountButton({
        role: 'floating',
        target: this.gallery.querySelector('slideshow-component > slideshow-container'),
        className: isGrid
          ? `${BUTTON_CLASS} ${BUTTON_CLASS}--floating ${BUTTON_CLASS}--mobile`
          : `${BUTTON_CLASS} ${BUTTON_CLASS}--floating`,
      });

      if (isGrid) {
        this.mountButton({
          role: 'grid',
          target: this.gallery.querySelector('.media-gallery__grid > .product-media-container'),
          className: `${BUTTON_CLASS} ${BUTTON_CLASS}--grid`,
        });
      }
    }

    mountButton({ role, target, className }) {
      const button = this.querySelector(`[data-role="${role}"]`);
      if (!button || !target || target.querySelector(`.${BUTTON_CLASS}--${role}`)) return;

      button.className = className;
      this.bindButton(button);
      target.append(button);
    }

    bindButton(button) {
      if (button.dataset.jaInitialized === 'true') return;

      button.dataset.jaInitialized = 'true';

      const prepare = () => this.prepareImages();
      const isolatePress = (event) => {
        event.stopPropagation();
        event.stopImmediatePropagation?.();
        prepare();
      };

      button.addEventListener('pointerdown', isolatePress);
      button.addEventListener('mousedown', isolatePress);
      button.addEventListener('touchstart', isolatePress, { passive: true });
      button.addEventListener('pointerenter', prepare);
      button.addEventListener('focus', prepare);
      button.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') prepare();
      });
    }

    prepareImages() {
      if (!this.gallery) return;

      this.gallery.querySelectorAll('.product-media-container--image .product-media__image').forEach((image) => {
        const productMedia = image.closest('.product-media');
        const mediaUrl = normalizeUrl(
          productMedia?.dataset.pinterestMediaUrl || image.currentSrc || image.src || this.fallbackImageUrl
        );
        const description = image.getAttribute('alt') || this.productTitle;

        if (this.productUrl) image.dataset.pinUrl = this.productUrl;
        if (mediaUrl) image.dataset.pinMedia = mediaUrl;
        if (description) image.dataset.pinDescription = description;
      });
    }
  }

  function normalizeUrl(value) {
    if (!value) return '';
    if (value.startsWith('//')) return `${window.location.protocol}${value}`;

    try {
      return new URL(value, window.location.origin).toString();
    } catch {
      return value;
    }
  }

  if (!customElements.get('ja-product-pinterest-save')) {
    customElements.define('ja-product-pinterest-save', JaProductPinterestSave);
  }
})();
